<template>
  <div>
    <div style="display: flex; height: 240px; width: 100%">
      <div @click="routerTo1()" id="tb6" style="width: 60%; height: 240px"></div>
      <div
        style="
          width: 40%;
          height: 240px;
          color: white;
          background-color: #0f0b26;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div style="font-size: 20px">
          <div>已缴:{{ sfyj }}</div>
          <div>未缴:{{ sfwj }}</div>
        </div>
      </div>
    </div>
    <div style="display: flex; height: 240px; width: 100%">
      <div @click="routerTo2()" id="tb7" style="width: 60%; height: 240px"></div>
      <div
        style="
          width: 40%;
          height: 240px;
          color: white;
          background-color: #0f0b26;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div style="font-size: 20px">
          <div>已缴:{{ dfyj }}</div>
          <div>未缴:{{ dfwj }}</div>
        </div>
      </div>
    </div>
    <div style="display: flex; height: 240px; width: 100%">
      <div @click="routerTo3()" id="tb8" style="width: 60%; height: 240px"></div>
      <div
        style="
          width: 40%;
          height: 240px;
          color: white;
          background-color: #0f0b26;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div style="font-size: 20px">
          <div>已缴:{{ wyfyj }}</div>
          <div>未缴:{{ wyfwj }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fwpj", "isTrue"],
  data() {
    return {
      sfyj: null,
      sfwj: null,
      dfwj: null,
      dfyj: null,
      wyfwj: null,
      wyfyj: null,
    };
  },
  watch: {
    isTrue(val) {
      if (val == true) {
        this.getJrqk();
        this.getDf();
        this.getWyf();
      }
    },
  },
  methods: {
    routerTo1() {
      this.$router.push({ path: "/index/reconciliation/waterRateReport" });
    },
    routerTo2() {
      this.$router.push({ path: "/index/reconciliation/indoorPowerRateReport" });
    },
    routerTo3() {
      this.$router.push({ path: "/index/reconciliation/propertyFeeReport" });
    },
    getJrqk() {
      let myChart = this.echarts.init(document.getElementById("tb6"), "dark");
      setTimeout(() => {
        this.$http.get("/api/screen/getMonthPay").then((res) => {
          this.sfyj = res.data.data.水费缴纳已缴数;
          this.sfwj = res.data.data.水费缴纳未缴数;
          this.dfyj = res.data.data.电费缴纳已缴数;
          this.dfwj = res.data.data.电费缴纳未缴数;
          this.wyfyj = res.data.data.物业费缴纳已缴数;
          this.wyfwj = res.data.data.物业费缴纳未缴数;
          let data = [
            {
              value: res.data.data.水费缴纳单位代缴数,
              name: "单位",
            },
            {
              value: res.data.data.水费缴纳个人代缴数,
              name: "个人",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "水费缴纳",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            legend: {
              x: "center",
              y: "bottom",
              data: ["单位缴纳", "个人缴纳"],
            },
            color: ["#FDDD60", "#58D9F9"],
            series: [
              {
                name: "水费缴纳",
                type: "pie",
                radius: "50%",
                data: data,
                avoidLabelOverlap: true, //图饼标签false重复
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ",
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        });
      }, 100);
    },
    getDf() {
      let myChart = this.echarts.init(document.getElementById("tb7"), "dark");
      setTimeout(() => {
        this.$http.get("/api/screen/getMonthPay").then((res) => {
          let data = [
            {
              value: res.data.data.电费缴纳单位代缴数,
              name: "单位",
            },
            {
              value: res.data.data.电费缴纳个人代缴数,
              name: "个人",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "电费缴纳",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            legend: {
              x: "center",
              y: "bottom",
              data: ["单位缴纳", "个人缴纳"],
            },
            color: ["#FDDD60", "#58D9F9"],
            series: [
              {
                name: "电费缴纳",
                type: "pie",
                radius: "50%",
                data: data,
                avoidLabelOverlap: true, //图饼标签false重复
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ",
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        });
      }, 100);
    },
    getWyf() {
      let myChart = this.echarts.init(document.getElementById("tb8"), "dark");
      setTimeout(() => {
        this.$http.get("/api/screen/getMonthPay").then((res) => {
          let data = [
            {
              value: res.data.data.物业费缴纳单位缴纳数,
              name: "单位",
            },
            {
              value: res.data.data.物业费缴纳个人代缴数,
              name: "个人",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "物业费缴纳",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            legend: {
              x: "center",
              y: "bottom",
              data: ["单位缴纳", "个人缴纳"],
            },
            color: ["#FDDD60", "#58D9F9"],
            series: [
              {
                name: "物业费缴纳",
                type: "pie",
                radius: "50%",
                data: data,
                avoidLabelOverlap: true, //图饼标签false重复
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ",
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        });
      }, 100);
    },
  },
};
</script>

<style scoped="scoped"></style>
